export default __webpack_public_path__ + "182f890e193b3af623faf0a291c9bd3f.ttf";